import React, { useState, useEffect } from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "../TextField";
import Button from "../Button";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
function SkillToImprove({ data, handleChange, onDelete, ...props }) {
  const { t } = useTranslation();
  const [skillImproveObj, setSkillImproveObj] = useState(data ? data : []);

  useEffect(() => {
    setSkillImproveObj(data);
  }, [data]);

  const handleSkillChange = (val, key, index) => {
    let currentObj = [...skillImproveObj];
    currentObj[index][key] = val;
    setSkillImproveObj(currentObj);
    handleChange(currentObj);
  };

  const handleSkillLevelChange = (val, key, index, levelIndex) => {
    let currentObj = [...skillImproveObj];
    if (typeof currentObj[index][key] === "string") {
      currentObj[index][key] = currentObj[index][key].split(",");
    }
    currentObj[index][key][levelIndex].skill_level_2 = val;
    setSkillImproveObj(currentObj);
    handleChange(currentObj, index);
  };

  const deleteSkillChange = index => {
    let currentObj = [...skillImproveObj];
    let deletedIds = currentObj[index].id;

    if (deletedIds?.length > 0) {
      onDelete(deletedIds);
    }
    currentObj.splice(index, 1);
    setSkillImproveObj(currentObj);
    handleChange(currentObj, index);
  };

  const deleteSkillLevelChange = (index, levelIndex) => {
    let currentObj = [...skillImproveObj];
    if (currentObj[index].skill_level_2[levelIndex].id) {
      onDelete(currentObj[index].skill_level_2[levelIndex].id);
    }
    currentObj[index].skill_level_2.splice(levelIndex, 1);
    setSkillImproveObj(currentObj);
    handleChange(currentObj, index);
  };

  const addLevel = index => {
    let currentObj = [...skillImproveObj];
    const newLevlobj = { skill_level_2: "" };
    if (typeof currentObj[index].skill_level_2 === "string") {
      currentObj[index].skill_level_2 =
        currentObj[index].skill_level_2.split(",");
      currentObj[index].skill_level_2.push(newLevlobj);
    } else if (!currentObj[index].skill_level_2) {
      currentObj[index].skill_level_2 = [newLevlobj];
    } else {
      currentObj[index].skill_level_2.push(newLevlobj);
    }
    setSkillImproveObj(currentObj);
  };

  const addSkillToImprove = () => {
    const obj = {
      skill_level_1: "",
      skill_level_2: [],
    };
    const currentObj = [...skillImproveObj, obj];
    setSkillImproveObj(currentObj);
  };

  return (
    <>
      <h6 className={styles.subhead}>
        {t("subjectManagement.skillToImprove")}
      </h6>
      {skillImproveObj &&
        skillImproveObj.map((item, index) => {
          const skill_level_2 =
            typeof item.skill_level_2 === "string"
              ? item.skill_level_2.split(",")
              : item.skill_level_2;
          return (
            <div className={styles.skillToImproveRow} key={index}>
              <div>
                <div>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label={t("subjectManagement.enterSkillToImprove")}
                    value={item.skill_level_1}
                    onChange={e => {
                      handleSkillChange(e.target.value, "skill_level_1", index);
                    }}
                  />
                  <DeleteIcon
                    color="action"
                    onClick={() => {
                      deleteSkillChange(index);
                    }}
                  />
                </div>
              </div>
              <div>
                {skill_level_2 &&
                  skill_level_2.map((level, levelIndex) => (
                    <div key={levelIndex}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label={t("subjectManagement.enterSkillToImprove")}
                        value={level.skill_level_2}
                        onChange={e => {
                          handleSkillLevelChange(
                            e.target.value,
                            "skill_level_2",
                            index,
                            levelIndex
                          );
                        }}
                      />
                      <DeleteIcon
                        color="action"
                        onClick={() => {
                          deleteSkillLevelChange(index, levelIndex);
                        }}
                      />
                    </div>
                  ))}
                <Button
                  style={{ color: "#0A859A", fontSize: "14px" }}
                  onClick={() => {
                    addLevel(index);
                  }}
                >
                  {" "}
                  {t("subjectManagement.addLevel")}
                </Button>
              </div>
            </div>
          );
        })}
      <div className={styles.skillToImproveRow}>
        <Button
          style={{ color: "#0A859A", fontSize: "14px" }}
          onClick={addSkillToImprove}
        >
          {" "}
          {t("subjectManagement.addSkillToImprove")}
        </Button>
      </div>
    </>
  );
}

export default SkillToImprove;
